exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kyc-modal{width:100%;text-align:center}.kyc-modal__container{padding-top:10px}.kyc-modal__title{display:block;color:#2e2727;font-size:1.6rem;text-transform:uppercase;line-height:1}.kyc-modal__subtitle{display:block;color:#2e2727;font-size:.8rem;text-transform:uppercase}.kyc-modal__active-step-link{color:#DB9922;text-decoration:underline}\n", ""]);

// exports
